
import { WorkspaceOrder } from '@/@types/WorkspaceOrder';
import { ConnectorConfig } from '@/models/ConnectorConfig';
import { Component, Prop, Vue } from 'vue-property-decorator';
import EventBus from '@/EventBus';

@Component
export default class MoreButton extends Vue {
  @Prop({ required: true, type: Object }) groupNode!: WorkspaceOrder;
  @Prop({ required: true, type: Boolean }) hasArticles!: boolean;
  @Prop({ default: false, type: Boolean }) isInsideIntegration!: boolean;

  get workspaceView() {
    return this.$store.state.workspaceView;
  }

  get allowEditWorkspace() {
    return this.workspaceView.workspace ? this.workspaceView.workspace.canEditArticles() : false;
  }

  get isIntegration(): boolean {
    return (this.groupNode as any).isIntegration === true;
  }

  get connectors(): ConnectorConfig[] {
    return this.$store.state.connector?.connectors || [];
  }

  get currentUserId(): string | null {
    return this.$store.state.user?.id ?? null;
  }

  get integrationConnector(): ConnectorConfig | null {
    if (!this.isIntegration) return null;
    const sourceType = (this.groupNode as any).sourceType;
    return (
      this.connectors.find(
        (c: ConnectorConfig) =>
          c.sourceType === sourceType && c.createdBy === this.currentUserId && c.status !== 'DISCONNECTED'
      ) || null
    );
  }

  get isStaleIntegration(): boolean {
    if (!this.isIntegration) return false;
    if (this.integrationConnector) return false;
    // Only show reconnect when there are actually stale articles for this sourceType
    const sourceType = (this.groupNode as any).sourceType;
    const articles = this.workspaceView.articles || [];
    return articles.some(
      (a: any) => a.syncStatus === 'STALE' && a.sourceType?.toUpperCase() === sourceType?.toUpperCase()
    );
  }

  handleReconnectIntegration() {
    this.$emit('reconnect-integration', (this.groupNode as any).sourceType);
  }

  handleReorderArticles() {
    EventBus.$emit('reorder-articles');
  }

  handleCreateSubArticle() {
    this.$emit('create-sub-article');
  }

  handleRenameGroup() {
    this.$emit('rename-group');
  }

  handleCopyGroupLink() {
    this.$emit('copy-group-link');
  }

  handleUngroup() {
    this.$emit('ungroup');
  }

  handleEditIntegration() {
    if (this.integrationConnector) {
      this.$emit('edit-integration', this.integrationConnector);
    }
  }

  handleRemoveIntegration() {
    if (this.integrationConnector) {
      this.$emit('remove-integration', this.integrationConnector);
    }
  }
}
